<template>
  <v-container fluid>
    <v-checkbox v-model="checkAll" :label="`Выбрать все`" dense></v-checkbox>
    <v-row justify="center">
      <v-expansion-panels accordion>
        <v-expansion-panel v-for="(domain, index) in model" :key="index">
          <v-expansion-panel-header>
            <v-checkbox
              class="pa-0"
              v-model="domain.checked"
              :label="domain.fullName"
              @click.native="check($event, domain)"
              dense
            ></v-checkbox>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="domain.is_interpolate_preset"
                  :label="`Интерполировать по территории`"
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="domain.is_interpolate_point"
                  :label="`Интерполировать в точку`"
                  dense
                ></v-checkbox>
                <v-container>
                  <v-select
                    v-model="domain.prioritet"
                    :items="prioritets"
                    label="Приоритет"
                    dense
                    outlined
                  ></v-select>
                </v-container>
              </v-col>
            </v-row>
            <v-row>
              <v-tabs background-color="primary" dark>
                <v-tab>Параметры</v-tab>
                <v-tab>Заблаговременности</v-tab>
                <v-tab-item>
                  <v-card>
                    <selected-parameter-list :model="domain.parameterLayersViewModel" />
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card>
                    <v-container>
                      <v-row>
                        <v-col cols="4">
                          <v-checkbox v-model="domain.checkedAll" :label="`Выбрать все`"></v-checkbox>
                        </v-col>
                        <v-col cols="4"></v-col>                        
                      </v-row>
                      <v-row>
                        <v-col cols="4" v-for="pr in domain.predictRanges" v-bind:key="pr.to">
                          <v-checkbox v-model="pr.checked" :label="getLableCheckBox(pr)" dense></v-checkbox>
                        </v-col>
                        <v-col cols="4"></v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          class="py-0"
                          cols="4"
                          v-for="predict in domain.predicts"
                          v-bind:key="predict.value"
                        >
                          <v-checkbox
                            v-model="predict.checked"
                            :label="getLable(predict.value)"
                            dense
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <WapiChangeDefaultPredicts v-model="changeDialog" @change="changeDefaultPredicts" />
  </v-container>
</template>


<script>
import Vue from "vue";
import VueCollapse from "vue2-collapse";
import WapiChangeDefaultPredicts from "./WapiChangeDefaultPredicts";
import SelectedParameterList from "./SelectedParameterList.vue";

Vue.use(VueCollapse);

export default {
  name: "SelectedDomainList",
  components: {
    WapiChangeDefaultPredicts,
    SelectedParameterList
  },
  props: {
    model: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  created() {
    this.prioritetViewModel = this.prioritets.map(x => {
      return {
        label: x,
        code: x
      };
    });
  },
  data: function() {
    return {
      prioritets: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      domains: [],
      response: [],
      currentPredicts: [],
      checkAll: false,
      prioritetViewModel: [],
      changeDialog: false,
      currentDomain: ""
    };
  },
  watch: {
    checkAll: function(newVal) {
      this.model.forEach(d => (d.checked = newVal));
    }
  },
  methods: {
    check: function(e, domain) {
      e.cancelBubble = true;
      domain.uncheck();
    },
    isCheckedAll(domain) {
      return !domain.predicts.some(d => !d.checked);
    },
    editPredicts(domain) {
      if (domain) {
        this.currentPredicts = domain.predicts;
      }
    },
    handleCheckPredicts(event, domain, range) {
      domain.predicts.forEach(d => {
        if (range.predicts.includes(d.value)) {
          d.checked = event.target.checked;
        }
      });
    },
    getLable(value) {
      return `${value} мин [${value / 60} ч]`;
    },
    getLableCheckBox(range) {
      return `Выбрать ${range.from}-${range.to} мин [${range.from /
        60}-${range.to / 60} ч]`;
    },
    changePredicts(domainName) {
      this.currentDomain = domainName;
      this.changeDialog = true;
    },
    changeDefaultPredicts(value) {
      const domain = this.model.find(x => x.name === this.currentDomain);
      domain.predicts = value;
      this.changeDialog = false;
    }
  }
};
</script>